module.exports = ":host {\n  /*height: calc(100vh - 74px);*/ }\n\n.container-fluid {\n  height: 100%;\n  min-height: 1500px; }\n\n.container-fluid .row,\n  .container-fluid .row > div {\n    height: 100%; }\n\n.hidden {\n  visibility: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.scss
// module id = ./src/app/dashboard/dashboard.component.scss
// module chunks = main